// announcement bar slider code //
$('.announcement-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 7000,
  infinite: true,
  dots: false,
  arrows: false,
});
		
/**
* simplePagination.js v1.6
* A simple jQuery pagination plugin.
* http://flaviusmatis.github.com/simplePagination.js/
*
* Copyright 2012, Flavius Matis
* Released under the MIT license.
* http://flaviusmatis.github.com/license.html
*/

(function($){

	var methods = {
		init: function(options) {
			var o = $.extend({
				items: 1,
				itemsOnPage: 1,
				pages: 0,
				displayedPages: 5,
				edges: 2,
				currentPage: 1,
				hrefTextPrefix: '#page-',
				hrefTextSuffix: '',
				prevText: 'Prev',
				nextText: 'Next',
				ellipseText: '&hellip;',
				cssStyle: 'light-theme',
				selectOnClick: true,
				onPageClick: function(pageNumber, event) {
					// Callback triggered when a page is clicked
					// Page number is given as an optional parameter
				},
				onInit: function() {
					// Callback triggered immediately after initialization
				}
			}, options || {});

			var self = this;

			o.pages = o.pages ? o.pages : Math.ceil(o.items / o.itemsOnPage) ? Math.ceil(o.items / o.itemsOnPage) : 1;
			o.currentPage = o.currentPage - 1;
			o.halfDisplayed = o.displayedPages / 2;

			this.each(function() {
				self.addClass(o.cssStyle + ' simple-pagination').data('pagination', o);
				methods._draw.call(self);
			});

			o.onInit();

			return this;
		},

		selectPage: function(page) {
			methods._selectPage.call(this, page - 1);
			return this;
		},

		prevPage: function() {
			var o = this.data('pagination');
			if (o.currentPage > 0) {
				methods._selectPage.call(this, o.currentPage - 1);
			}
			return this;
		},

		nextPage: function() {
			var o = this.data('pagination');
			if (o.currentPage < o.pages - 1) {
				methods._selectPage.call(this, o.currentPage + 1);
			}
			return this;
		},

		getPagesCount: function() {
			return this.data('pagination').pages;
		},

		getCurrentPage: function () {
			return this.data('pagination').currentPage + 1;
		},

		destroy: function(){
			this.empty();
			return this;
		},

		redraw: function(){
			methods._draw.call(this);
			return this;
		},

		disable: function(){
			var o = this.data('pagination');
			o.disabled = true;
			this.data('pagination', o);
			methods._draw.call(this);
			return this;
		},

		enable: function(){
			var o = this.data('pagination');
			o.disabled = false;
			this.data('pagination', o);
			methods._draw.call(this);
			return this;
		},

		updateItems: function (newItems) {
			var o = this.data('pagination');
			o.items = newItems;
			o.pages = Math.ceil(o.items / o.itemsOnPage) ? Math.ceil(o.items / o.itemsOnPage) : 1;
			this.data('pagination', o);
			methods._draw.call(this);
		},

		_draw: function() {
			var	o = this.data('pagination'),
				interval = methods._getInterval(o),
				i;

			methods.destroy.call(this);

			var $panel = this.prop("tagName") === "UL" ? this : $('<ul></ul>').appendTo(this);

			// Generate Prev link
			if (o.prevText) {
				methods._appendItem.call(this, o.currentPage - 1, {text: o.prevText, classes: 'prev'});
			}

			// Generate start edges
			if (interval.start > 0 && o.edges > 0) {
				var end = Math.min(o.edges, interval.start);
				for (i = 0; i < end; i++) {
					methods._appendItem.call(this, i);
				}
				if (o.edges < interval.start && (interval.start - o.edges != 1)) {
					$panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + '</span></li>');
				} else if (interval.start - o.edges == 1) {
					methods._appendItem.call(this, o.edges);
				}
			}

			// Generate interval links
			for (i = interval.start; i < interval.end; i++) {
				methods._appendItem.call(this, i);
			}

			// Generate end edges
			if (interval.end < o.pages && o.edges > 0) {
				if (o.pages - o.edges > interval.end && (o.pages - o.edges - interval.end != 1)) {
					$panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + '</span></li>');
				} else if (o.pages - o.edges - interval.end == 1) {
					methods._appendItem.call(this, interval.end++);
				}
				var begin = Math.max(o.pages - o.edges, interval.end);
				for (i = begin; i < o.pages; i++) {
					methods._appendItem.call(this, i);
				}
			}

			// Generate Next link
			if (o.nextText) {
				methods._appendItem.call(this, o.currentPage + 1, {text: o.nextText, classes: 'next'});
			}
		},

		_getInterval: function(o) {
			return {
				start: Math.ceil(o.currentPage > o.halfDisplayed ? Math.max(Math.min(o.currentPage - o.halfDisplayed, (o.pages - o.displayedPages)), 0) : 0),
				end: Math.ceil(o.currentPage > o.halfDisplayed ? Math.min(o.currentPage + o.halfDisplayed, o.pages) : Math.min(o.displayedPages, o.pages))
			};
		},

		_appendItem: function(pageIndex, opts) {
			var self = this, options, $link, o = self.data('pagination'), $linkWrapper = $('<li></li>'), $ul = self.find('ul');

			pageIndex = pageIndex < 0 ? 0 : (pageIndex < o.pages ? pageIndex : o.pages - 1);

			options = $.extend({
				text: pageIndex + 1,
				classes: ''
			}, opts || {});

			if (pageIndex == o.currentPage || o.disabled) {
				if (o.disabled) {
					$linkWrapper.addClass('disabled');
				} else {
					$linkWrapper.addClass('active');
				}
				$link = $('<span class="current">' + (options.text) + '</span>');
			} else {
				$link = $('<a href="' + o.hrefTextPrefix + (pageIndex + 1) + o.hrefTextSuffix + '" class="page-link">' + (options.text) + '</a>');
				$link.click(function(event){
					return methods._selectPage.call(self, pageIndex, event);
				});
			}

			if (options.classes) {
				$link.addClass(options.classes);
			}

			$linkWrapper.append($link);

			if ($ul.length) {
				$ul.append($linkWrapper);
			} else {
				self.append($linkWrapper);
			}
		},

		_selectPage: function(pageIndex, event) {
			var o = this.data('pagination');
			o.currentPage = pageIndex;
			if (o.selectOnClick) {
				methods._draw.call(this);
			}
			return o.onPageClick(pageIndex + 1, event);
		}

	};
	
	$.fn.pagination = function(method) {

		// Method calling logic
		if (methods[method] && method.charAt(0) != '_') {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Method ' +  method + ' does not exist on jQuery.pagination');
		}

	};

})(jQuery);
// ************************************************************************************************** //
// ************************************************************************************************** //
// ************************************************************************************************** //
var items = $(".list-wrapper .list-item");
    var numItems = items.length;
    var perPage = 4;

    items.slice(perPage).hide();
    if(numItems > 4){
      
    
    $('#pagination-container').pagination({
        items: numItems,
        itemsOnPage: perPage,
        prevText: "&laquo;",
        nextText: "&raquo;",
        onPageClick: function (pageNumber) {
            var showFrom = perPage * (pageNumber - 1);
            var showTo = showFrom + perPage;
            items.hide().slice(showFrom, showTo).show();
        }
    });
}
// ************************************************************************************************** //
// ************************************************************************************************** //
// ************************************************************************************************** //
$(document).ready(function(){
  var local = window.location;
  if(local == "https://stackandsprout.com/blogs/recipes"){
    $('.article_blog_nev .all.link_blog').addClass('active');
  }
  else if(local == "https://stackandsprout.com/blogs/recipes/"){
    $('.article_blog_nev .all.link_blog').addClass('active');
  }
  else{
  var tags = localStorage.getItem("tag");
  $('.article_blog_nev .link_blog').removeClass('active');
  $('.article_blog_nev .link_blog[data-handle="'+tags+'"]').addClass('active');
  }
 
});
$(document).on("click", ".filter-custom .all", function () {
    $(".filter-custom .link_blog").removeClass("active");
    $(this).addClass("active");
    $(".upper-sec").html(" ");
  localStorage.setItem("tag", "all");
    var newurl = "/blogs/recipes/";
    $.ajax({
      type: "GET",
      url: newurl,
      success: function (res) {
        //console.log(res);
        var gethtml = res;
        var getmain = $(gethtml).find(".upper-sec").html();
        $(".upper-sec").html(getmain);
        //console.log(getmain);
        history.pushState(null, null, newurl);
        var items = $(".list-wrapper .list-item");
    var numItems = items.length;
    var perPage = 4;
$('#pagination-container').removeClass('page-hide');
    items.slice(perPage).hide();
        
    $('#pagination-container').pagination({
        items: numItems,
        itemsOnPage: perPage,
        prevText: "&laquo;",
        nextText: "&raquo;",
        onPageClick: function (pageNumber) {
            var showFrom = perPage * (pageNumber - 1);
            var showTo = showFrom + perPage;
            items.hide().slice(showFrom, showTo).show();
        }
    });
      },
    }); 
  });
$(document).on("click", ".filter-custom .tags", function () {
  $(".filter-custom .link_blog").removeClass("active");
  $(this).addClass("active");

  var tag = $(this).attr("data-handle");
  localStorage.setItem("tag", tag );
  //console.log(tag);
  var newurl = "/blogs/recipes/tagged/" + tag;
  $.ajax({
    type: "GET",
    url: newurl,
    success: function (res) {
      //console.log(res);
      var gethtml = res;
      var getmain = $(gethtml).find(".upper-sec").html();
      $(".upper-sec").html(getmain);
      // console.log(getmain);
      history.pushState(null, null, newurl);
      var items = $(".list-wrapper .list-item");
    var numItems = items.length;
    var perPage = 4;
    items.slice(perPage).hide();
      if(numItems > 4){
        $('#pagination-container').removeClass('page-hide');
      }
      else{
        $('#pagination-container').addClass('page-hide');
      }
      
    $('#pagination-container').pagination({
        items: numItems,
        itemsOnPage: perPage,
        prevText: "&laquo;",
        nextText: "&raquo;",
        onPageClick: function (pageNumber) {
            var showFrom = perPage * (pageNumber - 1);
            var showTo = showFrom + perPage;
            items.hide().slice(showFrom, showTo).show();
        }
    });
    },
  });
});


// ************************************************************************************************** //
// ************************************************************************************************** //
// ************************************************************************************************** //


$(document).on("click", ".article_page .link_blog", function(){
  var value = $(this).text();
 var hr = window.location.href = "/blogs/recipes/tagged/"+value;
  localStorage.setItem("tag", value );
});
$(document).on("click", ".article_page .all", function(){
  var value = $(this).text();
  var hr = window.location.href = "/blogs/recipes/";
});

$(window).on('load', function() {
  var href = window.location.href;
  if (href.includes('recipes/')) {
  $('html, body').animate({
    scrollTop: $('#bottom-section').offset().top - 200
  }, 2000); 
  } else {
    
  }
});


$(document).on("click", ".page-link", function() {
  $('html, body').animate({
    scrollTop: $('#bottom-section').offset().top - 200
  }, 1000); 
});

// //////////////////////product-reviews section //////////////////////////////////////////

  function checkAndModifyYotpoReviews() {
    let intervalId;
    let timeElapsed = 0;
    const intervalDuration = 500; // Check every 500ms
    const maxDuration = 10000; // 10 seconds

    intervalId = setInterval(() => {
      timeElapsed += intervalDuration;

      // Try to select the .yotpo-reviews-list element
      const reviewsList = document.querySelector('.yotpo-reviews-list');

      if (reviewsList) {
        // If found, clear the interval
        clearInterval(intervalId);

        // Remove all .yotpo-review-border-smooth elements
        const reviewBorders = reviewsList.querySelectorAll('.yotpo-review-border-smooth');
        reviewBorders.forEach(border => border.remove());

        // Get the reviews and votes elements
        const reviews = reviewsList.querySelectorAll('.yotpo-review');
        const votesWrappers = reviewsList.querySelectorAll('.yotpo-review-votes-wrapper');

        // Store the pagination element to re-append later
        const pagination = reviewsList.querySelector('.yotpo-reviews-pagination-container');

        // Clear the inner HTML of the reviews list
        reviewsList.innerHTML = '';
        const newReviewItemnewMain = document.createElement('div');
         newReviewItemnewMain.classList.add('yotpo-reviews-list-item-new-main');
        
        // Iterate through reviews and votes, and wrap them in a new .yotpo-reviews-list-item div
        reviews.forEach((review, index) => {
          const votes = votesWrappers[index];

          // Create the new wrapper div
          const newReviewItem = document.createElement('div');
          newReviewItem.classList.add('yotpo-reviews-list-item');

          const newReviewIteminner = document.createElement('div');
          newReviewIteminner.classList.add('yotpo-reviews-inner');

          // Append the review and votes to the new div
          newReviewIteminner.appendChild(review);
          //newReviewIteminner.appendChild(votes);
          newReviewItem.appendChild(newReviewIteminner);
          // Append the new div to the reviews list
          newReviewItemnewMain.appendChild(newReviewItem);
        });
       reviewsList.appendChild(newReviewItemnewMain);
        // Re-append the pagination element to the end of the reviews list
        if (pagination) {
          reviewsList.appendChild(pagination);
        }
      var backButton = '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71" fill="none"><circle cx="35.5" cy="35.5" r="34.3906" transform="matrix(-1 0 0 1 71 0)" fill="white" stroke="white" stroke-width="2.21875"/><path d="M39.9375 24.4062L28.8438 36.7326L39.9375 48.8125" stroke="#345751" stroke-width="2" stroke-linecap="round"/></svg></div>';
      var nextButton = '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71" fill="none"><circle cx="35.5" cy="35.5" r="34.3906" fill="white" stroke="white" stroke-width="2.21875"/><path d="M31.0625 24.4062L42.1562 36.7326L31.0625 48.8125" stroke="#345751" stroke-width="2" stroke-linecap="round"/></svg></div>';
      $('.yotpo-reviews-list-item-new-main').slick({
        dots: false,
        infinite: false,
        rows: 0,
        prevArrow: backButton,
        nextArrow: nextButton,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              dots: true
            }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      }).on('setPosition', function (event, slick) {
      	slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
      $(document).on('click', '.yotpo-read-more', function(){
          $('.yotpo-reviews-list-item-new-main').slick('refresh');
      });
      
        


        
      } else if (timeElapsed >= maxDuration) {
        // Clear the interval if the maximum time is reached
        clearInterval(intervalId);
        console.log('Element .yotpo-reviews-list not found within the time limit.');
      }
    }, intervalDuration);
  }

  // Call the function to start checking
  checkAndModifyYotpoReviews();

